import { useTranslation } from 'react-i18next';
import React from 'react';
import { SectionHeader, Typography } from 'web-library';

const SubjectSelectionLabel = () => {
  const { t } = useTranslation();
  return (
    <>
      <SectionHeader title={t('resit->>RegisterResit.Select Subject(s)')} />

      <Typography variant="body1">
        {t(
          'resit->>RegisterResit.Below are the subjects and papers that you are eligible to register for a resit.'
        )}
      </Typography>
    </>
  );
};

export default SubjectSelectionLabel;
